import React from "react";

// The sixteen identity hues live in _palette.scss as --avatar-1..16; this was a
// verbatim JS copy of the same list, which is a second source that can drift.
// Deliberately theme-INVARIANT — an avatar that changed colour with the theme
// would change identity, which is the one thing the ramp exists to prevent.
const COLORS = Array.from({ length: 16 }, (_, i) => `var(--avatar-${i + 1})`);

function getInitials(name) {
  if (!name) return "?";
  const parts = name.trim().split(" ").filter(Boolean);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

function getColor(name) {
  if (!name) return COLORS[0];
  const idx = name.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return COLORS[idx % COLORS.length];
}

const DashboardAvatar = ({ name, size = 32 }) => (
  <div
    className="db-avatar"
    style={{ width: size, height: size, fontSize: size * 0.38, background: getColor(name) }}
  >
    {getInitials(name)}
  </div>
);

export default DashboardAvatar;
